import { isObjectControl, and, rankWith, optionIs } from "@jsonforms/core";

export default rankWith(5, and(isObjectControl, optionIs("addressOrder", true)));
